module.exports = __webpack_public_path__ + "img/pexels-cup-of-couple-7303151.d3a8f0e4.jpg";